import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../config/routingUrl';

const SectionAboutBlog = () => {
    const  navigate  =  useNavigate();
    return (
        <div className="container-fluid" style={{ padding: "10px 0px 0px 0px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "center" }}>
            <div className="container" style={{display:"flex",flexDirection:"column", justifyContent: "center" }}>
                <div className="row" style={{ position: "relative", top: -50, justifyContent: "center" }}>
                    {/* Section gauche */}
                    <div className="col-md-6">
                        <div style={{ position: "relative" }} className="rounded-lg">
                            <img className="rounded-lg" src="design/images/vehicle_about.jpeg" alt="Image de la section gauche" style={{ width: "400px", height: "300px" }} />
                            <div className="rounded-lg" style={{ position: "absolute", zIndex: 50, display: "flex", alignContent: "end", justifyContent: "start", width: "400px", height: "300px", top: "0%", bottom: "0%", left: "0%", right: "0%", background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(9, 28, 0, 0.9) 78.85%)" }}>
                                <div style={{ position: "relative", width: "100%", color: "white" }}>
                                    <div className="p-3" style={{ position: "absolute", width: "100%", bottom: "0%", right: "0%", left: "0%" }}>
                                        <h4 className="text-white text-start" >Location de voitures à
                                            des tarifs imbattables </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Paragraphe supplémentaire */}
                        <div style={{ width: "400px" }} className="pt-5">
                            <p>
                                Chez Mareza, nous vous proposons une large gamme de véhicules et  proprités adaptés à tous vos besoins. Que ce soit pour un voyage d{"'"}affaires, des vacances en famille ou une escapade entre amis, nous avons le véhicule parfait pour vous.
                                Profitez de nos tarifs compétitifs et de nos offres exceptionnelles qui vous  permettent de voyager sans vous ruiner. Avec Mareza, la route est à  vous !
                            </p>
                        </div>
                    </div>

                    {/* Section droite */}
                    <div className="col-md-6">
                        <div style={{ position: "relative" }} className="rounded-lg">
                            <img className="rounded-lg" src="design/images/property_about.jpeg" alt="Image de la section droite" style={{ width: "400px", height: "300px" }} />
                            <div className="rounded-lg" style={{ position: "absolute", zIndex: 50, display: "flex", alignContent: "end", justifyContent: "start", width: "400px", height: "300px", top: "0%", bottom: "0%", left: "0%", right: "0%", background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(9, 28, 0, 0.9) 78.85%)" }}>
                                <div style={{ position: "relative", width: "100%", color: "white" }}>
                                    <div className="p-3" style={{ position: "absolute", width: "100%", bottom: "0%", right: "0%", left: "0%" }}>
                                        <h4 className="text-white text-start" >Votre partenaire de confiance
                                            pour la location </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Paragraphe supplémentaire */}
                        <div style={{ width: "400px" }} className="pt-5">
                            <p style={{ color: "#000000" }}>
                                Choisissez Mareza pour une expérience de location de voiture sans  tracas. Nous offrons une variété de modèles récents et bien entretenus,  garantissant confort et sécurité lors de vos déplacements.
                                Avec  notre processus de réservation simple et rapide, vous pouvez facilement  planifier votre voyage et vous concentrer sur ce qui compte le plus –  créer des souvenirs inoubliables.
                            </p>
                        </div>
                    </div>
                </div>
                <div style={{ padding: "100px", display: "flex", justifyContent: "center" }}>
                    <div>
                        <Button type="button" onClick={() => { navigate(`/${ROUTES.CAR_LIST_WEB}`) }} style={{ color: "#42B711", boxShadow: "0px 0px 2.5px #42B711", background: "white", border: "1.5px #42B711 solid", padding: "25px 30px 25px 30px", fontSize: "20px", fontWeight: "bold", borderRadius: "30px" }}> Exporer les offres </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SectionAboutBlog;